import { Box } from "@mui/material";
import { FormInput } from "Components/Shared/Inputs/Form/FormInput";
import type { LicenseFormData } from "Components/Users/UserDetailPageContent/Components/LicenseForm/schema";
import { PaymentStatusDropdown } from "Components/Users/UserDetailPageContent/Components/PaymentStatusDropdown";
import type { ReactNode } from "react";
import type { Control } from "react-hook-form";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Licenses.Form.Fields;

type LicenseFormFieldsProps = {
  control: Control<LicenseFormData>;
  sendInvoiceButtonSlot: ReactNode;
  transferButtonSlot: ReactNode;
  isLicenseNoLocked: boolean;
};

export const LicenseFormFields = ({
  control,
  sendInvoiceButtonSlot,
  transferButtonSlot,
  isLicenseNoLocked,
}: LicenseFormFieldsProps) => {
  const { t } = useResource();

  return (
    <Box
      component="fieldset"
      sx={{ all: "unset", display: "grid", width: "100%" }}
    >
      <FormInput
        control={control}
        name="code"
        label={t(COMPONENT_RESOURCES.Code)}
        disabled
      />
      <Box display="flex" gap={2} alignItems="flex-start">
        <Box flex={1}>
          <FormInput
            control={control}
            name="licenseNo"
            label={t(COMPONENT_RESOURCES.LicenseNo)}
            disabled={isLicenseNoLocked}
          />
        </Box>
        {transferButtonSlot}
      </Box>
      <FormInput
        control={control}
        name="paymentDate"
        label={t(COMPONENT_RESOURCES.PaymentDate)}
        type="date"
      />
      <PaymentStatusDropdown
        control={control}
        name="paymentStatus"
        label={t(COMPONENT_RESOURCES.PaymentStatus.label)}
      />
      <Box mt={1} mb={5}>
        {sendInvoiceButtonSlot}
      </Box>
      <FormInput
        control={control}
        name="walletAddress"
        label={t(COMPONENT_RESOURCES.WalletAddress)}
        disabled
      />
    </Box>
  );
};
